const buildPageUrl = ({ type, path, page, uuid }) => {
  switch (type) {
    case 'landing':
      return '/guide';

    case 'survey':
      return `/guide/spa/${ uuid }/${ path.key }/${ page.key }`;

    case 'summary':
      return `/guide/${ uuid }/summary`;

    case 'details':
      return `/guide/${ uuid }/details`;

    default:
      return '/guide';
  }
};

export default buildPageUrl;
